import { PasswordPolicy } from '@angular/fire/auth';
import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

function escapeForRegex(characters?: string): string {
  if (!characters) return '';
  return characters.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export function passwordPolicyValidator(policy: PasswordPolicy): ValidatorFn | null {
  const opts = policy?.customStrengthOptions;
  if (opts == null) {
    return null;
  }
  const allowedSpecialChars = policy.allowedNonAlphanumericCharacters ?? '';
  const validators: ValidatorFn[] = [];

  if (opts.minPasswordLength) {
    validators.push(Validators.minLength(opts.minPasswordLength));
  }
  if (opts.maxPasswordLength) {
    validators.push(Validators.maxLength(opts.maxPasswordLength));
  }

  // Custom validators
  validators.push((control: AbstractControl) => {
    const value: string = control.value || '';
    const errors: any = {};

    if (opts.containsLowercaseLetter && !/[a-z]/.test(value)) {
      errors.missingLowercase = true;
    }

    if (opts.containsUppercaseLetter && !/[A-Z]/.test(value)) {
      errors.missingUppercase = true;
    }

    if (opts.containsNumericCharacter && !/[0-9]/.test(value)) {
      errors.missingNumber = true;
    }

    if (opts.containsNonAlphanumericCharacter) {
      const escapedChars = escapeForRegex(allowedSpecialChars);
      if (escapedChars) {
        const regex = new RegExp(`[${escapedChars}]`);
        if (!regex.test(value)) {
          errors.missingSpecialChar = true;
        }
      } else {
        errors.missingSpecialChar = true;
      }
    }

    return Object.keys(errors).length ? errors : null;
  });

  return Validators.compose(validators);
}
